import React from 'react';
import { Button, Modal, Space, Typography, Flex, Avatar, Divider } from 'antd';
import { LinkOutlined } from '@ant-design/icons';

import { useEvent } from '../events/hooks/useEvent';
import { SALES_TEAM } from './contacts';

type ContactSalesModalProps = {
  open: boolean;
  onClose: () => void;
  eventsTrackingData: Record<string, unknown>;
};

function ContactSalesModal({ open, onClose, eventsTrackingData }: ContactSalesModalProps) {
  const { track } = useEvent();

  return (
    <Modal
      title={SALES_TEAM.title}
      open={open}
      onCancel={onClose}
      footer={[
        <Button key="close" onClick={onClose}>
          Close
        </Button>,
      ]}
    >
      <Space direction="vertical" size="large">
        <Typography.Paragraph>
          <p>{SALES_TEAM.description}</p>
        </Typography.Paragraph>

        <Flex gap="large" align="center">
          <Flex flex={1} vertical align="center" gap="small">
            <Typography.Text strong>{SALES_TEAM.name}</Typography.Text>
            <Avatar size={100} src={SALES_TEAM.picture} gap={12} />
          </Flex>
          <Flex flex={3} vertical>
            <Typography.Text style={{ textAlign: 'center' }}>
              You can reach out via email at{' '}
              <Typography.Link href={`mailto:${SALES_TEAM.email}`}>{SALES_TEAM.email}</Typography.Link>
            </Typography.Text>
            <Divider plain>Or</Divider>
            <Button
              type="primary"
              href={SALES_TEAM.bookMeetingURL}
              target="_blank"
              icon={<LinkOutlined />}
              onClick={() => track('Book meeting clicked (Sales)', eventsTrackingData)}
            >
              Book a meeting
            </Button>
          </Flex>
        </Flex>
      </Space>
    </Modal>
  );
}

export default ContactSalesModal;
